import { request } from '@/util/request';
import { ModelWidgetSchema } from '@/components/business/crud/interface/ModelWidgetSchema';

interface MenuDatum {
  id: string;
  class?: string;
  path?: string;
  title: string;
  children?: MenuDatum[];
}

export type MenuData = MenuDatum[];

class App {
  /**
   * 是否初始化
   */

  /**
   * 数据
   */
  data = {
    authRule: [],
    menu: [] as MenuData,
    availableMenu: [] as MenuData,
    widgetMap: {} as Record<string, Record<string, ModelWidgetSchema>>,
    auths: new Set(),
    isInit: false,
  };

  async init() {
    const data = await request('management/system/getConfig', null);
    if (data) {
      this.data.authRule = data.authRule;
      this.data.menu = data.menu;
      this.data.availableMenu = this.filterMenu(data.menu, new Set(data.menus));
      this.data.widgetMap = data.widgetMap;
      this.data.auths = new Set(data.auths);
      this.data.isInit = true;
      return true;
    }
  }

  private filterMenu(menus: MenuData, menuSet: Set<string>): MenuData {
    return menus
      .filter((i) => menuSet.has(i.id))
      .map((i) => {
        return {
          ...i,
          children: i.children
            ? this.filterMenu(i.children, menuSet)
            : undefined,
        };
      });
  }

  hasAuth(id: string) {
    return this.data.auths.has(id);
  }
}

export const app = new App();
